import { createSetPropMutation } from '@/store/utils';
import * as types from '@/store/spCompanyRegistration/mutationTypes';

export default {
  [types.REMOVE_SP_COMPANY_REGISTRATION_DATA](state) {
    state.spCompanyRegistrationMainInfo = {};
    state.spCompanyRegistrationCompanyIpAddressInfo = [];
    state.spCompanyRegistrationCompanySocialNetworkLinkInfo = {};
    state.spCompanyRegistrationCompanyRecommendationInfo = {};
    state.spCompanyRegistrationCompanyCertificationInfo = {};
    state.spCompanyServices = [];
    state.spCompanyRegions = [];
    state.spCompanyEmployeesAmount = [];
    state.spCompanyCertificates = [];
    state.spCompanyClientAvatar = null;
    state.spCompanyRegistrationEmailVerificationInfo = {};
    state.spCompanyServicesInfo = {};
    state.spCompanyCurrentStep = 1;
    state.spCompanyVisitedStepsCnt = 1;
    state.spCompanyFilledStepsCnt = 0;
    state.spCompanyLoading = {};
    state.spCompanyLoadingErrors = {};
    state.spCompanyRecaptchaToken = null;
    state.spCompanyEmailVerificationSent = false;
    state.spCompanyRegions = [];
    state.spCompanyAmountOfEmployees = [];
    state.companySuggestionsForSP = [];
  },
  [types.SET_COMPANY_SUGGESTIONS_FOR_SP]: createSetPropMutation('companySuggestionsForSP'),
  [types.SET_SP_COMPANY_MAIN_INFO]: createSetPropMutation('spCompanyRegistrationMainInfo'),
  [types.SET_SP_COMPANY_RECOMMENDATION_INFO]: createSetPropMutation('spCompanyRegistrationCompanyRecommendationInfo'),
  [types.SET_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO]: createSetPropMutation('spCompanyRegistrationCompanySocialNetworkLinkInfo'),
  [types.SET_SP_COMPANY_IP_ADDRESS_INFO]: createSetPropMutation('spCompanyRegistrationCompanyIpAddressInfo'),
  [types.SET_SP_COMPANY_CERTIFICATION_INFO]: createSetPropMutation('spCompanyRegistrationCompanyCertificationInfo'),
  [types.SET_SP_COMPANY_SERVICES_INFO]: createSetPropMutation('spCompanyServicesInfo'),
  [types.SET_SP_COMPANY_EMAIL_VERIFICATION_INFO]: createSetPropMutation('spCompanyRegistrationEmailVerificationInfo'),

  [types.SET_SP_COMPANY_REGISTRATION_CURRENT_STEP]: createSetPropMutation('spCompanyCurrentStep'),
  [types.SET_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT]: createSetPropMutation('spCompanyFilledStepsCnt'),
  [types.SET_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT]: createSetPropMutation('spCompanyVisitedStepsCnt'),
  [types.SET_SERVICES_SP_COMPANY]: createSetPropMutation('spCompanyServices'),
  [types.SET_CERTIFICATES_SP_COMPANY]: createSetPropMutation('spCompanyCertificates'),
  [types.SET_REGIONS_SP_COMPANY]: createSetPropMutation('spCompanyRegions'),
  [types.SET_EMPLOYEES_AMOUNT_SP_COMPANY]: createSetPropMutation('spCompanyAmountOfEmployees'),

  [types.SET_SP_COMPANY_SUGGEST_INFO_LOADING_ERRORS]: createSetPropMutation('spCompanyLoadingErrors'),
  [types.SET_SP_COMPANY_SUGGEST_INFO_LOADING]: createSetPropMutation('spCompanyLoading'),
  [types.SET_SP_COMPANY_CERTIFICATES_INFO_LOADING]: createSetPropMutation('spCompanyLoading'),
  [types.SET_SP_COMPANY_CERTIFICATES_INFO_LOADING_ERRORS]: createSetPropMutation('spCompanyLoadingErrors'),
  [types.SET_SP_COMPANY_SERVICES_INFO_LOADING]: createSetPropMutation('spCompanyLoading'),
  [types.SET_SP_COMPANY_SERVICES_INFO_LOADING_ERRORS]: createSetPropMutation('spCompanyLoadingErrors'),
  [types.SET_SP_COMPANY_REGIONS_INFO_LOADING]: createSetPropMutation('spCompanyLoading'),
  [types.SET_SP_COMPANY_REGIONS_INFO_LOADING_ERRORS]: createSetPropMutation('spCompanyLoadingErrors'),
  [types.SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING]: createSetPropMutation('spCompanyLoading'),
  [types.SET_SP_COMPANY_EMPLOYEES_AMOUNT_INFO_LOADING_ERRORS]: createSetPropMutation('spCompanyLoadingErrors'),
  [types.SET_SP_COMPANY_CLIENT_AVATAR]: createSetPropMutation('spCompanyClientAvatar'),
  [types.SET_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN]: createSetPropMutation('spCompanyRecaptchaToken'),
  [types.SET_SP_COMPANY_EMAIL_VERIFICATION_REQUESTED]: createSetPropMutation('spCompanyEmailVerificationSent'),
};
